import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-jqeasing-effects',
	templateUrl:'./JQEasingEffectsPluginCompPage.html',
	styles: [],
	styleUrls:['./JQEasingEffectsPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQEasingEffectsPluginCompPage
{
	mdContent_991 = `\`\`\`java
import com.jwebmp.plugins.easingeffects.JQEasingEffects;
\`\`\``;
	mdContent_992 = `\`\`\`java
accordion.getOptions().getAnimate()
    .setEasing(JQEasingEffects.easeInOutQuad);
\`\`\``;
	mdContent_993 = `\`\`\`java
accordion.getOptions().getAnimate()
    .setEasing(JQEasingEffects.easeOutBounce);
\`\`\``;
}
